import { useState, useEffect } from 'react';

interface RecentItem {
  id: string;
  timestamp: number;
}

export const useRecentItems = (key: string, maxItems: number = 5) => {
  const [recentItems, setRecentItems] = useState<RecentItem[]>(() => {
    const saved = localStorage.getItem(key);
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(recentItems));
    console.log(`Recent ${key} saved to localStorage:`, recentItems);
  }, [recentItems, key]);

  const addRecentItem = (id: string) => {
    setRecentItems(prev => {
      const filtered = prev.filter(item => item.id !== id);
      const newItems = [{ id, timestamp: Date.now() }, ...filtered].slice(0, maxItems);
      return newItems;
    });
  };

  const clearRecentItems = () => {
    setRecentItems([]);
    localStorage.removeItem(key);
  };

  return { recentItems, addRecentItem, clearRecentItems };
};